export default "__VITE_ASSET__DdrKja6n__"